var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClasses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#4e443d",
    strokeWidth: 6,
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M63.3295019,27 L63.3295019,15 C63.3295019,12.2385763 65.5680782,10 68.3295019,10 C71.0909257,10 73.3295019,12.2385763 73.3295019,15 L73.3295019,27 C73.3295019,29.7614237 71.0909257,32 68.3295019,32 C65.5680782,32 63.3295019,29.7614237 63.3295019,27 Z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0,27 L0,15 C-3.38176876e-16,12.2385763 2.23857625,10 5,10 C7.76142375,10 10,12.2385763 10,15 L10,27 C10,29.7614237 7.76142375,32 5,32 C2.23857625,32 3.38176876e-16,29.7614237 0,27 Z",
    transform: "rotate(-180 5 21)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8883157,21 L57.5588138,21 L14.8883157,21 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M51.5588138,37 L51.5588138,5 C51.5588138,2.23857625 53.79739,2.27880941e-13 56.5588138,2.27373675e-13 C59.3202375,2.2686641e-13 61.5588138,2.23857625 61.5588138,5 L61.5588138,37 C61.5588138,39.7614237 59.3202375,42 56.5588138,42 C53.79739,42 51.5588138,39.7614237 51.5588138,37 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.7706881,37 L11.7706881,5 C11.7706881,2.23857625 14.0092644,5.07265313e-16 16.7706881,0 C19.5321119,-5.07265313e-16 21.7706881,2.23857625 21.7706881,5 L21.7706881,37 C21.7706881,39.7614237 19.5321119,42 16.7706881,42 C14.0092644,42 11.7706881,39.7614237 11.7706881,37 Z",
    transform: "rotate(-180 16.77 21)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/classes.807645ff3afeb28f242a7fe858daae48.svg";
export { ForwardRef as ReactComponent };